var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKontor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.001,
    height: 54,
    viewBox: "0 0 53.001 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 26.5,
    cy: 27,
    rx: 26.5,
    ry: 27,
    transform: "translate(0.442 0.158)",
    fill: "#b7dc8f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Industri_logistikk",
    "data-name": "Industri/logistikk",
    transform: "translate(-310 -364)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_100-2",
    "data-name": "Ellipse 100",
    cx: 26.5,
    cy: 27,
    rx: 26.5,
    ry: 27,
    transform: "translate(310 364)",
    fill: "#b7dc8f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(309.559 363.842)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Industri",
    transform: "translate(11.584 7.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_copy",
    "data-name": "Layer 1 copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M14.836,3.63c.011-.45-.056-1.063.321-1.389a.406.406,0,0,1,.426-.063c.124.055.161.183.278.247A1.452,1.452,0,0,1,16.7,1.011c.384-.149.662.321.721.65.018.1,0,.307.112.364s.247-.069.352-.077c.348-.024.472.482.482.747.2-.223.321-.177.456.1.077-.161.061-.352.148-.515a.618.618,0,0,1,.536-.329c.39-.013.352.443.581.631-.1-.821.79-1.957,1.652-1.85.7.088,1.02,1.1.935,1.713-.039-.27.13-.633.45-.5.2.079.472.356.434.586.031-.161.223-.421.4-.321a.4.4,0,0,1,.159.384c.112-.161.321-.257.482-.095a1.053,1.053,0,0,1,.25.578.552.552,0,0,1,.634-.358.413.413,0,0,1,.3.53c.276-.08.262.416.25.567-1.209.114-2.437-.055-3.653.034-.633.045-1.272.035-1.9.09-.22.021-.443.034-.663.048-.1,0-.249-.027-.321.024Z",
    transform: "translate(-3.723 -0.179)",
    fill: "#7bbf2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M33.359,4.059a.482.482,0,0,1-.021-.352,1.779,1.779,0,0,1,.279-.723c.239-.246.482.18.6.348-.051-.265.374-.186.382,0-.045-.44.047-1.167.467-1.408.321-.186.482.064.578.339.018-.153.021-.273.185-.352a.612.612,0,0,1,.576.077.944.944,0,0,1,.345.517,2.365,2.365,0,0,0,.095.4.753.753,0,0,1,.573-.422c.265-.01.307.238.424.426.083-.161.161-.376.361-.417.228-.047.411.223.527.382.254.347.132.7.161,1.09a2.426,2.426,0,0,1-.849.027h-.713c-.223,0-.435-.043-.655-.047Z",
    transform: "translate(-8.359 -0.464)",
    fill: "#7bbf2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M14.739,3.058a.459.459,0,0,0-.575-.242c-.04-.22-.047-.5-.3-.589-.284-.108-.422.066-.623.207a1.063,1.063,0,0,0-.4-.8.5.5,0,0,0-.726.289c-.122-.393-.385-.812-.861-.782-.445.029-1.244.427-1.145.973-.186-.294-.305-.581-.642-.726-.4-.161-.578.143-.718.472-.075-.385-.161-.686-.567-.849a.541.541,0,0,0-.69.482C7.392,1.089,7.279.063,6.767,0c-.419-.048-.7.623-.829.915a4.014,4.014,0,0,0-.35,1.352c-.071-.228-.469-.737-.735-.734-.442,0-.61.864-.61,1.188-.206-.223-.523-.732-.851-.528a1.734,1.734,0,0,0-.417,1.766l11.759-.286a.1.1,0,0,0,.059,0C14.776,3.435,14.89,3.281,14.739,3.058Z",
    transform: "translate(-0.728 0.003)",
    fill: "#62af23"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_301",
    "data-name": "Rectangle 301",
    width: 23.304,
    height: 50.154,
    transform: "translate(7.067 3.779)",
    fill: "#6bcdd8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_302",
    "data-name": "Rectangle 302",
    width: 3.541,
    height: 4.616,
    transform: "translate(9.867 8.334)",
    fill: "#61becc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_303",
    "data-name": "Rectangle 303",
    width: 3.541,
    height: 4.616,
    transform: "translate(24.294 13.001)",
    fill: "#61becc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_304",
    "data-name": "Rectangle 304",
    width: 3.541,
    height: 4.618,
    transform: "translate(24.294 22.367)",
    fill: "#61becc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_305",
    "data-name": "Rectangle 305",
    width: 3.541,
    height: 4.616,
    transform: "translate(17.093 13.001)",
    fill: "#61becc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_306",
    "data-name": "Rectangle 306",
    width: 3.541,
    height: 4.616,
    transform: "translate(17.03 8.334)",
    fill: "#61becc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(7.067 3.779)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M9.434,24.546V39.3l23.3-32.7V5.042H23.331Z",
    transform: "translate(-9.434 -5.042)",
    fill: "#88e2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M32.737,18.2V11.886l-23.3,32.7v6.317Z",
    transform: "translate(-9.434 -6.759)",
    fill: "#88e2e0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_307",
    "data-name": "Rectangle 307",
    width: 6.481,
    height: 50.154,
    transform: "translate(0.586 3.779)",
    fill: "#509aa9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M32.737,9.923V9.64H30.344V6.064h-.286V9.64H26.744V6.064h-.292V9.64H23.144V6.064h-.286V9.64H19.548V6.064H19.26V9.64H15.945V6.064h-.287V9.64H12.345V6.064h-.287V9.64H9.432v.283h2.625v4.411H9.432v.283h2.625v4.408H9.432v.283h2.625v4.411H9.432V24h2.625v4.412H9.432v.281h2.625v4.412H9.432v.281h2.625v4.422H9.432v.281h2.625V42.5H9.432v.283h2.625V47.2H9.432v.283h2.625v4.411H9.432v.283h2.625V55.4h.287V52.165h3.313v3.223h.287V52.165h3.313v3.223h.291V52.165h3.314v3.223h.286V52.165h3.3v3.223h.286V52.165h3.314v3.223h.286V52.165H32.73v-.283H30.338V47.472H32.73v-.283H30.338V42.779H32.73V42.5H30.338V38.083H32.73v-.273H30.338V33.39H32.73v-.281H30.338V28.7H32.73v-.281H30.338V24H32.73v-.283H30.338V19.31H32.73v-.286H30.338V14.616H32.73v-.283H30.338V9.923Zm-17.08,41.96H12.345V47.472h3.313Zm0-4.693H12.345V42.779h3.313Zm0-4.693H12.345V38.083h3.313Zm0-4.693H12.345V33.39h3.313Zm0-4.693H12.345V28.7h3.313Zm0-4.693H12.345V24h3.313Zm0-4.7H12.345V19.31h3.313Zm0-4.693H12.345V14.616h3.313Zm0-4.693H12.345V9.923h3.313Zm3.6,37.549H15.945V47.472h3.313Zm0-4.693H15.945V42.779h3.313Zm0-4.693H15.945V38.083h3.313Zm0-4.693H15.945V33.39h3.313Zm0-4.693H15.945V28.7h3.313Zm0-4.693H15.945V24h3.313Zm0-4.7H15.945V19.31h3.313Zm0-4.693H15.945V14.616h3.313Zm0-4.693H15.945V9.923h3.313Zm3.6,37.549H19.548V47.472h3.314Zm0-4.693H19.548V42.779h3.314Zm0-4.693H19.548V38.083h3.314Zm0-4.693H19.548V33.39h3.314Zm0-4.693H19.548V28.7h3.314Zm0-4.693H19.548V24h3.314Zm0-4.7H19.548V19.31h3.314Zm0-4.693H19.548V14.616h3.314Zm0-4.693H19.548V9.923h3.314Zm3.594,37.549H23.144V47.472h3.308Zm0-4.693H23.144V42.779h3.308Zm0-4.693H23.144V38.083h3.308Zm0-4.685H23.144V33.39h3.308Zm0-4.693H23.144V28.7h3.308Zm0-4.693H23.144V24h3.308Zm0-4.7H23.144V19.31h3.308Zm0-4.7H23.144V14.616h3.308Zm0-4.693H23.144V9.923h3.308Zm3.6,37.549H26.744V47.472h3.314Zm0-4.693H26.744V42.779h3.314Zm0-4.693H26.744V38.083h3.314Zm0-4.693H26.744V33.39h3.314Zm0-4.693H26.744V28.7h3.314Zm0-4.693H26.744V24h3.314Zm0-4.7H26.744V19.31h3.314Zm0-4.693H26.744V14.616h3.314Zm0-4.693H26.744V9.923h3.314Z",
    transform: "translate(-2.367 -1.519)",
    fill: "#5ab5c3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_308",
    "data-name": "Rectangle 308",
    width: 24.832,
    height: 1.328,
    transform: "translate(5.869 3.248)",
    fill: "#5ab5c3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_309",
    "data-name": "Rectangle 309",
    width: 5.869,
    height: 1.328,
    transform: "translate(0 3.248)",
    fill: "#609fae"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKontor);
export default __webpack_public_path__ + "static/media/Kontor.0994841690f119405276e878c5c5a482.svg";
export { ForwardRef as ReactComponent };